<template>

    <div class="main-container">
        <!-- Background Image Grid -->
        <div class="image-grid">
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-lg-block">
                <img v-no-right-click src="https://dummyimage.com/300x400/007bff/007bff" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/6610f2/6610f2" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image"> 
            </div>
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-lg-block">
                <img v-no-right-click src="https://dummyimage.com/300x400/007bff/007bff" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/6610f2/6610f2" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image">  
                <img v-no-right-click src="https://dummyimage.com/300x350/17a2b8/17a2b8" alt="Grid Image">  
            </div> 
            <div class="image-column">
                <img v-no-right-click src="https://dummyimage.com/300x400/e83e8c/e83e8c" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/20c997/20c997" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x350/fd7e14/fd7e14" alt="Grid Image"> 
            </div>
            <div class="image-column d-none d-md-block">
                <img v-no-right-click src="https://dummyimage.com/300x350/6f42c1/6f42c1" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x400/dc3545/dc3545" alt="Grid Image">
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
                <img v-no-right-click src="https://dummyimage.com/300x300/28a745/28a745" alt="Grid Image"> 
            </div> 
        </div>

        <!-- Login Form Container -->
        <div class="login-container">
            <div class="login-box">
                <div class="text-center mb-4">
                    <img v-no-right-click src="/assets/logo-icon.png" style="height:55px" alt="Logo" class="logo rounded">
                    <h2 class="welcome-text">Login to Invi8</h2>
                </div>  

                <form @submit.prevent="handleLogin" autocomplete="none">
                    <div class="form-group">
                        <input type="text" v-model="form.username" class="form-control" placeholder="Username">
                    </div>
                    <div class="form-group password-group">
                        <input
                          :type="showPassword ? 'text' : 'password'"
                          v-model="form.password"
                          class="form-control"
                          placeholder="Password"
                        >
                        <button
                          type="button"
                          class="toggle-password"
                          @click="showPassword = !showPassword"
                          :aria-label="showPassword ? 'Hide password' : 'Show password'"
                        >
                          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                        </button>
                    </div>
                    <button type="submit" class="btn btn-pinterest btn-block">Log in</button>
                    <div class="row py-3">
                        <div class="col-6"><router-link to="/forgot-password" class="forgot-password">Forgot password?</router-link></div>
                        <div class="col-6 text-right"><router-link to="/register" class="signup-link"><i class="fas fa-sign-in-alt mr-2"></i>Register</router-link></div>
                    </div>

                </form>
                    <div class="divider">
                        <span>OR</span>
                    </div>
                    <button type="button" @click="handleGoogleLogin" class="btn btn-google btn-block">
                       <i class="fab fa-google mr-2"></i>  Continue with Google
                    </button>   
            </div>
        </div>
    </div> 
 
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import Swal from 'sweetalert2'
import { useSessionStore } from '@/stores/session'
import api from '@/services/api'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import { auth } from '@/services/firebase'
import { useHead } from '@vueuse/head'


useHead({
  title: 'Invi8 - User Login',
  meta: [
    { name: 'description', content: 'Welcome to the home page of My Awesome Site.' },
    { name: 'keywords', content: 'home, awesome site, vue 3, pwa' },
  ],
})

const router = useRouter()
const store = useSessionStore()

const form = reactive({
  username: '',
  password: ''
})
const showPassword = ref(false)

const resolveRedirect = () => {
  const r = router.currentRoute?.value?.query?.redirect
  return (typeof r === 'string' && r.startsWith('/')) ? r : ''
}

const handleLogin = async () => {
  if (!form.username || !form.password) {
    Swal.fire('Error', 'Both fields are required!', 'error')
    return
  }

  try {
    const formData = new FormData()
    formData.append('username', form.username)
    formData.append('password', form.password)

    const { data } = await api.loginApi(formData)

    console.log('Login API Response:', data) // for debugging

    if (data.status === 'ok' && data.data.length > 0) {
      store.setUser(data.data[0]) // ✅ store full user object
      await store.fetchProfile(true) // fetch latest profile so navbar updates immediately
      const redirect = resolveRedirect() || '/host'
      router.push(redirect)
    } else {
      Swal.fire('Login Failed', 'Invalid credentials.', 'error')
    }
  } catch (err) {
    Swal.fire('Server Error', 'Something went wrong.', 'error')
  }
}


const handleGoogleLogin = async () => {
  try {
    const provider = new GoogleAuthProvider()
    const result = await signInWithPopup(auth, provider)

    const user = result.user
    const name = user.displayName
    const email = user.email

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    const offsetMinutes = new Date().getTimezoneOffset()
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60)
    const offsetMins = Math.abs(offsetMinutes) % 60
    const sign = offsetMinutes <= 0 ? '+' : '-'
    const offsetzone = `GMT${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`
    
    const formData = new FormData()
    formData.append('name', name || '')
    formData.append('email', email || '')
    formData.append('timezone', timezone)
    formData.append('offsetzone', offsetzone)
    formData.append('login_type', 'google') 

    const { data } = await api.socialLoginApi(formData)
    console.log('Social Login Response:', data)

    if (data.status === 'ok' && data.data?.length) {
      store.setUser(data.data[0])
      await store.fetchProfile(true)
      Swal.fire('Welcome!', `Logged in as ${name}`, 'success')
      const redirect = resolveRedirect() || '/host'
      router.push(redirect)
    } else {
      Swal.fire('Login Failed', 'Google account not linked.', 'error')
    }

  } catch (error) {
    Swal.fire('Google Login Failed', error.message, 'error')
  }
}


</script>

<style>
/* Main Container */
.main-container {
    min-height: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
}

/* Image Grid Styles */
.image-grid {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    opacity: 1;
    z-index: -1;
}

.image-column {
    flex: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.image-column img {
    width: 100%;
    border-radius: 16px;
    object-fit: cover;
    margin-bottom: 20px;
}

/* Login Container Styles */
.login-container {
    width: 100%;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 0px;
    background: rgba(255, 255, 255, 0.9);
}

.login-box {
    background: white;
    padding: 30px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
}

/* Logo and Welcome Text */
.logo {
    border-radius: 50%;
    margin-bottom: 10px;
}

.welcome-text {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
}

/* Form Elements */
.form-control {
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
    border: 2px solid #efefef;
}

.form-control:focus {
    border-color: #FB7210;
    box-shadow: none;
}

.password-group {
    position: relative;
}
.password-group .form-control {
    padding-right: 42px;
}
.toggle-password {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
}
.toggle-password:focus {
    outline: none;
}

.forgot-password {
    color: #FB7210;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
}

.forgot-password:hover {
    color: #333;
    text-decoration: none;
}

.signup-link {
    color: #FB7210;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
}

.signup-link:hover {
    color: #333;
    text-decoration: none;
}

/* Buttons */
.btn {
    border-radius: 20px;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 15px;
}

.btn-pinterest {
    background-color: #FB7210;
    color: white;
    border: none;
}

.btn-pinterest:hover {
    background-color: #ad081b;
    color: white;
}

.btn-facebook {
    background-color: #1877f2;
    color: white;
    border: none;
}

.btn-facebook:hover {
    background-color: #0d65d9;
    color: white;
}

.btn-google {
    background-color: white;
    color: #333;
    border: 2px solid #efefef;
}

.btn-google:hover {
    background-color: #f8f8f8;
}

/* Divider */
.divider {
    text-align: center;
    margin: 20px 0;
    position: relative;
}

.divider::before,
.divider::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 45%;
    height: 1px;
    background-color: #efefef;
}

.divider::before {
    left: 0;
}

.divider::after {
    right: 0;
}

.divider span {
    background-color: white;
    padding: 0 10px;
    color: #666;
    font-size: 14px;
}

/* Business Text */
.business-text {
    color: #666;
    font-size: 12px;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .login-box {
        padding: 20px;
    }
    
    .welcome-text {
        font-size: 24px;
    }
    
    .image-grid {
        opacity: 0.2;
    }
}

@media (max-width: 576px) {
    .login-container {
        padding: 10px;
    }
    
    .login-box {
        box-shadow: none;
    }
    
    .image-grid {
        opacity: 0.1;
    }
} 
</style>
